import * as React from 'react';
import { getText, getConfig } from '../../helpers';
import TileCarousel from '../_common/tile-carousel';
import SectionTitle from '../_common/section-title';

const slickOptions = getConfig('components.carouselOptions');
const title = getText('generic.relatedDatasets');

const relatedDatasets = function RelatedDatasets({ dataProfile, className, scrollTo }: RelatedDatasetsProps) {
    if (!dataProfile.marketDatasetDatasets) return null;
    return (
        <div id="related-dataset" className="page-section">
            <div className="page-section__inner">
                <SectionTitle
                    hash="related-dataset"
                    text={title}
                    onClick={scrollTo}
                />
            </div>
            <TileCarousel
                dataIds={dataProfile.marketDatasetDatasets.sort((a: MarketDatasetDataset, b: MarketDatasetDataset) => a.FormOrder - b.FormOrder).map(x => { if (x.KeyMarketplaceDatasetRelated === null) return x.KeyMarketplaceDatasetBundle; return x.KeyMarketplaceDatasetRelated; })}
                slickOptions={slickOptions}
                className={className}
            />
        </div>
    );
};

export default React.memo(relatedDatasets);
